import {
  CreditFacilityPayoutListItemModel, CreditFacilityPayoutModel,
} from '../redux/types';
import useFetchClient from "./useFetchClient";
import { useAppDispatch } from "../redux/hooks";
import { restConfig } from "../authConfig";
import { createUrlWithQueryString } from '../utils/url';
import { getPaginationDataFromResponse } from '../utils/responseHelper';
import { loading, creditFacilityPayoutsFetchFailure, creditFacilityPayoutsFetched, creditFacilityPayoutDetailsFetched } from '../redux/slices/creditFacilityPayoutSlice';
import { payoutCreditFacilityDetailsFetchFailure } from '../redux/slices/payoutCreditFacilitySlice';

const useCreditFacilityPayoutActions = () => {
  const fetchClient = useFetchClient()
  const dispatch = useAppDispatch()

  const getCreditFacilityPayouts = (payoutCreditFacilityId: string, searchTerm: string, pageIndex: number, pageSize: number) => {
    dispatch(loading())

    const params = {
      query: searchTerm,
      pageNumber: pageIndex,
      pageSize: pageSize
    }
    const url = createUrlWithQueryString(restConfig.routes.payoutCreditFacilities + `/${payoutCreditFacilityId}/payouts`, params)

    return fetchClient.get(url)
      .then(response => {
          const paginationData = getPaginationDataFromResponse(response.raw)
          dispatch(creditFacilityPayoutsFetched({ items: response.data as CreditFacilityPayoutListItemModel[], totalCount: paginationData?.totalItemCount ?? 0}))
      })
      .catch(error => {
          console.log('getCreditFacilityPayouts error:', error)
          dispatch(creditFacilityPayoutsFetchFailure(error))
      })
  }

  const getCreditFacilityPayoutDetailsById = (payoutCreditFacilityId: string, id: string) => {
    dispatch(loading())   

    const url = restConfig.routes.payoutCreditFacilities + `/${payoutCreditFacilityId}/payouts/${id}`

    return fetchClient.get(url)
      .then(response => {
          dispatch(creditFacilityPayoutDetailsFetched(response.data as CreditFacilityPayoutModel))
      })
      .catch(error => {
          console.log('getCreditFacilityPayoutDetailsById error:', error)
          dispatch(payoutCreditFacilityDetailsFetchFailure(error))
      })
  }

  return {
    getCreditFacilityPayouts,
    getCreditFacilityPayoutDetailsById
  }
}

export default useCreditFacilityPayoutActions
